export interface Node {
  id: string;
  type: 'person' | 'vehicle' | 'location' | 'phone' | 'generic';
  label: string;
  position: { x: number; y: number };
  color: string;
  tags: string[];
  notesMd: string;
  tsStart?: number;
  tsEnd?: number;
  image?: string;
  shape?: 'rectangle' | 'circle';
  width?: number;
  height?: number;
  isResizable?: boolean;
  customEntityType?: string;
  backgroundColor?: string;
  attachments: Attachment[];
}

export interface Edge {
  id: string;
  source: string;
  target: string;
  sourceHandle?: string | null;
  targetHandle?: string | null;
  label?: string;
  color?: string;
  ts?: number;
  notesMd?: string;
}

export interface Attachment {
  id: string;
  nodeId: string;
  name: string;
  mime: string;
  size: number;
  objectUrl: string;
}

export interface Board {
  id: string;
  title: string;
  createdAt: number;
  updatedAt: number;
  nodes: Node[];
  edges: Edge[];
  caseMetadata?: CaseMetadata;
}

export interface CaseMetadata {
  caseNumber?: string;
  caseType?: 'homicide' | 'fraud' | 'cyber' | 'missing_person' | 'narcotics' | 'other';
  victimName?: string;
  suspectName?: string;
  incidentLocation?: string;
  investigatorName?: string;
  status?: 'active' | 'closed' | 'cold' | 'archived';
  dateOpened?: number;
}

export interface AppState {
  currentBoard: Board | null;
  selectedNodeId: string | null;
  selectedEdgeId: string | null;
  timelineRange: [number, number];
  snapToGrid: boolean;
  showTimeline: boolean;
}

export const NODE_TYPES = {
  person: { color: '#3B82F6', label: 'Person' },
  vehicle: { color: '#EF4444', label: 'Vehicle' },
  location: { color: '#10B981', label: 'Location' },
  phone: { color: '#F59E0B', label: 'Phone' },
  generic: { color: '#6B7280', label: 'Generic' }
} as const;